import React from 'react';
import { useSelector } from 'react-redux';
import { getPath, selectIsMobileView } from 'selectors';
import { Container, PageBreadcrumbs } from 'common/components';
import NAVBAR_LINKS from './navbar-links.json';
import { RulesContent } from './styles';
import { Navbar, CurrentPage } from './components';

export const Rules = () => {
	const isMobileView = useSelector(selectIsMobileView);
	const path = useSelector(getPath);
	const title = (NAVBAR_LINKS.find(({ link }) => path === link) || {}).label;

	return (
		<Container>
			{!isMobileView && <PageBreadcrumbs />}
			<RulesContent>
				<CurrentPage title={title} path={path} />
				<Navbar isMobileView={isMobileView} />
			</RulesContent>
		</Container>
	);
};
